// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"AlertsList_contentComponent__2CW0J","tableContainer":"AlertsList_tableContainer__3b5QW"};